import axios from "axios";

/**
 * Base axios instances
 * Do NOT force Content-Type here; we’ll set per-request.
 */
const api = axios.create({
  baseURL: "https://api.mysite.co.id/dashboard/",
  timeout: 10000,
  withCredentials: true,
  validateStatus: (status) => true,
});

const apiSlow = axios.create({
  baseURL: "https://api.mysite.co.id/dashboard/",
  timeout: 60000,
  withCredentials: true,
});

/**
 * Helper: convert plain object -> URLSearchParams
 */
function toFormUrlEncoded(data) {
  const params = new URLSearchParams();
  Object.keys(data || {}).forEach((key) => {
    const value = data[key];
    if (value !== undefined && value !== null) {
      params.append(key, value);
    }
  });
  return params;
}

/**
 * Helper: detect FormData
 */
function isFormData(body) {
  return typeof FormData !== "undefined" && body instanceof FormData;
}

/**
 * Public POST (no auth)
 */
export async function apiPostPublic(endpoint, data = {}) {
  try {
    let payload;
    let headers = {};

    if (isFormData(data)) {
      // File / multipart case → let axios set Content-Type
      payload = data;
    } else {
      // Default: URL encoded for PHP $_POST
      payload = toFormUrlEncoded(data);
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    const response = await api.post(endpoint, payload, {
      withCredentials: true,
      headers,
    });

    return response.data;
  } catch (error) {
    // handle/log as needed
  }
}

/**
 * Authenticated POST
 */
export async function apiPostAuth(endpoint, data = {}) {
  try {
    let payload;
    let headers = {};

    if (isFormData(data)) {
      // For uploads: keep FormData, do NOT set Content-Type manually
      payload = data;
    } else {
      // For normal requests: use urlencoded
      payload = toFormUrlEncoded(data);
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    const response = await api.post(endpoint, payload, {
      withCredentials: true,
      headers,
    });

    // Handle 401 centralized
    if (response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    //throw error;
  }
}

/**
 * Authenticated POST (slow / long-running)
 */
export async function apiPostAuthSlow(endpoint, data = {}) {
  try {
    let payload;
    let headers = {};

    if (isFormData(data)) {
      payload = data;
    } else {
      payload = toFormUrlEncoded(data);
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    const response = await apiSlow.post(endpoint, payload, {
      withCredentials: true,
      headers,
    });

    if (response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    // swallow or handle as you wish
  }
}

/**
 * GET request
 */
export async function apiGet(endpoint, params = {}, requireAuth = false) {
  try {
    const response = await api.get(endpoint, {
      params,
      withCredentials: requireAuth,
    });

    if (requireAuth && response.status === 401) {
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }

    return response.data;
  } catch (error) {
    if (
      requireAuth &&
      error.response &&
      error.response.status === 401 &&
      window.location.pathname.startsWith("/dashboard")
    ) {
      window.location.href = "/login";
    }
  }
}
